import { CSSProperties } from "react";

import { useTheme } from "@hooks";
import { constants, spacing } from "@layout";

import { VerificationBannerVariant } from "./types";

export const useStyles = (variant: VerificationBannerVariant) => {
  const { theme } = useTheme();

  const backgroundColor =
    variant === "inProgress"
      ? theme.verification.banner.contributions.inProgress
      : theme.verification.banner.contributions.error;

  const styles: Record<string, CSSProperties> = {
    container: {
      display: "flex",
      flexDirection: "row",
      padding: spacing.m,
      backgroundColor,
      borderRadius: constants.radius.view,
      width: "100%",
      boxSizing: "border-box",
      alignItems: "center",
    },
    icon: {
      marginRight: spacing.m,
      flexShrink: 0,
    },
    content: {
      display: "flex",
      flexDirection: "column",
      flex: 1,
    },
    title: {
      fontWeight: 600,
      marginBottom: spacing.xs,
    },
  };

  return styles;
};
